
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M122.7 95.5H5.3c-1.4 0-2.7.5-3.8 1.6-1.1 1-1.6 2.3-1.6 3.7v10.5c0 1.4.5 2.7 1.6 3.7s2.3 1.6 3.8 1.6h117.3c1.4 0 2.7-.5 3.7-1.6 1.1-1 1.6-2.3 1.6-3.7v-10.5c0-1.4-.5-2.7-1.6-3.7-.9-1.1-2.2-1.6-3.6-1.6zm3.7-82.4c-1.1-1-2.3-1.6-3.7-1.6H5.3c-1.4 0-2.7.5-3.8 1.6-1.1 1-1.6 2.3-1.6 3.7v10.5c0 1.4.5 2.7 1.6 3.7s2.3 1.6 3.8 1.6h117.3c1.4 0 2.7-.5 3.7-1.6 1.1-1 1.6-2.3 1.6-3.7V16.7c.1-1.4-.4-2.6-1.5-3.6zm-3.7 40.4H5.3c-1.4 0-2.7.5-3.8 1.6-1.1 1-1.6 2.3-1.6 3.7v10.5c0 1.4.5 2.7 1.6 3.7s2.3 1.6 3.8 1.6h117.3c1.4 0 2.7-.5 3.7-1.6 1.1-1 1.6-2.3 1.6-3.7V58.7c0-1.4-.5-2.7-1.6-3.7-.9-1-2.2-1.5-3.6-1.5z"}})])
          )
        }
      }
    